<div class="container">
  <app-search-bar [searchParams]="searchParameters"></app-search-bar>
</div>
<div class="container">
  <div class="row">
    <div class="col-md-8 col-sm-12">
      <app-practitioner-list [selectedPractitioner]="selectedPractitioner" [results]="searchResults" [resultsLoaded]="resultsLoaded"></app-practitioner-list>
    </div>
    <div class="col-md-4 flex-column col-sm-12" style="padding-top: 30px; padding-bottom: 30px;" *ngIf="searchResults.length > 0 && currentWindowWidth > 767">
      <div class="sticky-top">
        <agm-map [zoom]="10" [latitude]="searchResults[0].practitioner.location.latitude" [longitude]="searchResults[0].practitioner.location.longitude">
          <agm-marker
            *ngFor="let result of searchResults"
            [latitude]="result.practitioner.location.latitude"
            [longitude]="result.practitioner.location.longitude"
            [markerDraggable]="false"
            (markerClick)="practitionerSelected(result)"></agm-marker>
        </agm-map>
      </div>
    </div>
  </div>
</div>
